export default __webpack_public_path__ + "static/media/2333.85fed444.png";